import Element from 'Prototype/UI/Element';
import Game from 'Game';
import GameObject, { GameObjectEvent } from 'GameObject/GameObject';
import { applyDefaultButtonAnimation } from 'System/UI/UIHelper';
import { UIActions } from 'State/UI/UIActions';
import ButtonComponent from 'Component/UI/ButtonComponent';
import { FBTrackingEvent } from 'Utility/Tracking/FBTrackingEvent';
import { isShopSupported } from 'Utility/Platform';
import Renderable from 'Component/Renderable';
import { IGameState } from 'State/Game/IGameState';
import { StartAnimation } from 'System/Animation/AnimationHelper';
import StateComponent from 'Component/State';
import { AnimationClipEvent } from 'System/Animation/AnimationClip';
import Point from 'Utility/Point';
import { PopupID } from 'State/UI/PopupID';
import { SHOP_UNLOCK_LEVEL } from 'Constants/Shop';

export default class ShopButton extends Element {
    public static _name: string;
    public static BTN_NAME: string = 'button';

    private notification: Element;

    public create(params: { highestLevel: number; [key: string]: any }): void {
        ShopButton._name = params.name;

        super.create({
            name: params.name,
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
                ...params.layout,
            },
            children: [
                {
                    name: 'button',
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        scale: [1, 1],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'shop',
                            },
                        },
                        {
                            type: 'input',
                            data: {
                                enabled: true,
                                buttonMode: true,
                                toggleable: true,
                                tintOnDisable: true,
                            },
                        },
                    ],
                    children: [
                        {
                            name: 'notification',
                            layout: {
                                anchors: [0.5, 0.5, 0.5, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [-49, 35, -49, 35],
                                scale: [0.9, 0.9],
                            },
                            components: [
                                {
                                    type: 'image',
                                    data: {
                                        cacheKey: 'notification',
                                    },
                                },
                            ]
                        },
                    ],
                },
            ],
            ...params,
        });

        this.notification = this.findChildByName('notification') as Element;
        this.notification.getComponent<Renderable>(Renderable).visible = false;
        const button: GameObject = this.button;
        button.addComponent(ButtonComponent, {
            toggleable: true,
        });
        button.on(GameObjectEvent.SELECTED, this.onSelect.bind(this));
        button.getComponent<Renderable>(Renderable).visible =
            isShopSupported() && params.highestLevel >= SHOP_UNLOCK_LEVEL;
        applyDefaultButtonAnimation(button);

        this.addComponent(StateComponent, {
            handleStateChanged: this.handleStateChanged.bind(this),
        });
    }

    private onSelect(): void {
        UIActions.showPopup(PopupID.SHOP_MENU, {});

        try {
            Game.sdk.gameTracking(FBTrackingEvent.OpenShop_ShopIcon);
        } catch (e) {
            console.error('Failed to track', e);
        }
    }

    public get button(): GameObject {
        return this.findChildByName(ShopButton.BTN_NAME);
    }

    private handleStateChanged(state: IGameState): void {
        const notificationRenderable: Renderable = this.notification.getComponent<
            Renderable
        >(Renderable);
        if (
            state.playerState.inventory.shopGift > 0 &&
            !notificationRenderable.visible
        ) {
            StartAnimation(this.notification, 'UIPopIn').once(
                AnimationClipEvent.COMPLETE,
                () => {
                    StartAnimation(this.notification, 'PulseLoop', {
                        duration: 350,
                        scale1: new Point(0.9, 0.9),
                        scale2: new Point(1.15, 1.15),
                        delay: 2000,
                    });
                    /* StartAnimation(this.text, 'Wiggle', {
                        loop: true,
                        duration: 130,
                        delay: 2000,
                    }); */
                }
            );
        } else if (
            state.playerState.inventory.shopGift < 1 &&
            notificationRenderable.visible
        ) {
            StartAnimation(this.notification, 'UIPopOut');
        }
    }
}
